export const serializePartner = partner => ({
  name: partner.name,
  id: partner.id,
});

export const serializePartnerToMap = partners =>
  partners.map(partner => serializePartner(partner));
